import camelize from 'camelize'
import queryString from 'query-string'
import React, { createContext, useContext } from 'react'

import { AVERAGE } from '../config/speeds'

const PageContext = createContext()

const PageProvider = ({
  value: {
    slug = '',
    newsSlug = '',
    orderings = [],
    crumbs = [],
    questionLedJourney = false,
    nonServiceabilityPage = false,
    speeds = AVERAGE,
    filterConfig = [],
    listnames = null,
    funnelHeader = null,
    noFooter = null,
    locality = '',
    providerId = '',
    previewFlag = false,
    connectionTypes = [],
    pageId,
    contentId,
    scope,
    helmet,
    location,
    match,
    history,
    params,
    embeddedEeveeEntityIds,
    returnUrl,
    hideTabs = false,
    ...rest
  },
  children
}) => {
  const URLparams = queryString.parse(location.search)

  const additionalValues = {
    path: location.pathname,
    params: { ...params, ...camelize(URLparams) },
    nonServiceabilityPage: URLparams['all-deals'] === 'true' ? true : nonServiceabilityPage,
    previewFlag: URLparams.preview === 'true'
  }

  return (
    <PageContext.Provider
      value={{
        slug,
        newsSlug,
        orderings,
        crumbs,
        questionLedJourney,
        nonServiceabilityPage,
        speeds,
        filterConfig,
        listnames,
        funnelHeader,
        noFooter,
        locality,
        providerId,
        previewFlag,
        connectionTypes,
        pageId,
        contentId,
        scope,
        helmet,
        location,
        match,
        history,
        params,
        embeddedEeveeEntityIds,
        returnUrl,
        hideTabs,
        ...rest,
        ...additionalValues
      }}
    >
      {children}
    </PageContext.Provider>
  )
}

const usePageContext = () => {
  const pageContext = useContext(PageContext)

  return pageContext
}

export { PageProvider, PageContext, usePageContext }
